/* eslint-disable max-len, no-console, padded-blocks, prefer-destructuring */
import Vue from 'vue';
import VueRouter from 'vue-router';
/* import * as Msal from '@azure/msal-browser'; */
import store from '@/store';

import MySites from '@/views/MySites.vue';
import PlanDetails from '@/components/projects/PlanDetails.vue';
import Project from '@/views/Project.vue';
import ProjectActions from '@/components/projects/ProjectActions.vue';
import ProjectBudget from '@/components/projects/ProjectBudget.vue';
import ProjectContacts from '@/components/projects/ProjectContacts.vue';
import ProjectGoals from '@/components/projects/ProjectGoals.vue';
import ProjectIncentives from '@/components/projects/ProjectIncentives.vue';
import ProjectOverview from '@/components/projects/ProjectOverview.vue';
import ProjectWorkorders from '@/components/projects/ProjectWorkorders.vue';
import ProjectOutcomes from '@/components/projects/ProjectOutcomes.vue';
import NotAuthorized from '../views/NotAuthorized.vue';
import SignIn from '../views/SignIn.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/mysites',
    name: 'MySites',
    component: MySites,
  },
  {
    path: '/',
    name: 'Dashboard',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/Dashboard.vue'),
  },
  {
    path: '/newprojectsbudgetstatus',
    name: 'NewProjectsBudgetStatus',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/NewProjectsBudgetStatus.vue'),
  },
  {
    path: '/exportBills',
    name: 'ExportBills',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/ExportBills.vue'),
  },
  {
    path: '/Admin',
    name: 'Admin',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/Admin.vue'),
  },
  {
    path: '/TOGmanagement',
    name: 'TOGmanagement',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../components/admin/TOGmanagement.vue'),
  },
  {
    path: '/AddTOG',
    name: 'AddTOG',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../components/admin/AddTOG.vue'),
  },
  {
    path: '/EditTOG',
    name: 'EditTOG',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../components/admin/EditTOG.vue'),
  },
  {
    path: '/site/:id',
    name: 'Site',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/Site.vue'),
  },
  {
    path: '/site/:id/assessment',
    name: 'SiteAssessment',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/SiteAssessment.vue'),
  },
  {
    path: '/managementplan',
    name: 'ManagementPlan',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/ManagementPlan.vue'),
  },
  {
    path: '/managementplan/:id',
    name: 'ManagementPlanForm',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/ManagementPlanForm.vue'),
  },
  {
    path: '/site/:id/managementplans',
    name: 'ManagementPlans',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/ManagementPlans.vue'),
  },
  {
    path: '/project/:id',
    name: 'Project',
    component: Project,
    children: [
      {
        path: 'actions',
        name: 'ProjectActions',
        component: ProjectActions,
      },
      {
        path: 'budget',
        name: 'ProjectBudget',
        component: ProjectBudget,
      },
      {
        path: 'contacts',
        name: 'ProjectContacts',
        component: ProjectContacts,
      },
      {
        path: 'goals',
        name: 'ProjectGoals',
        component: ProjectGoals,
      },
      {
        path: 'incentives',
        name: 'ProjectIncentives',
        component: ProjectIncentives,
      },
      {
        path: 'overview',
        name: 'ProjectOverview',
        component: ProjectOverview,
      },
      {
        path: 'planDetails',
        name: 'PlanDetails',
        component: PlanDetails,
      },
      {
        path: 'workorders',
        name: 'ProjectWorkorders',
        component: ProjectWorkorders,
      },
      {
        path: 'workorders/:workorderId',
        name: 'ProjectWorkorderDrilldown',
        component: ProjectWorkorders,
      },
      {
        path: 'workorders/:workorderId/bill/:billId',
        name: 'ProjectWorkorderBillDrilldown',
        component: ProjectWorkorders,
      },
      {
        path: 'outcomes',
        name: 'ProjectOutcomes',
        component: ProjectOutcomes,
      },
    ],
  },
  {
    path: '/site/:id/visit',
    name: 'SiteVisit',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/SiteVisit.vue'),
  },
  {
    path: '/signin',
    name: 'SignIn',
    component: SignIn,
  },
  {
    path: '/notauthorized',
    name: 'NotAuthorized',
    component: NotAuthorized,
  },
  {
    path: '/authorized',
    name: 'Authorized',
  },
];

const router = new VueRouter({
  mode: 'history',
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  routes,
});

router.beforeEach(async (to, from, next) => {
  // these routes don't need authentication
  if (to.name === 'SignIn' || to.name === 'NotAuthorized' || to.name === 'Authorized') {
    next();
  } else if (router.app.$msal.isAuthenticated) {
    next();
  } else {
    await store.dispatch('ReturnTo/setReturnTo', to);
    router.app.$msal.signIn(router);
  }
});

export default router;
